import React from 'react';
import ImageUploader from '../ImageUploader';

function EditFactionFormDetails({
  formData,
  isFavoriteLocal,
  setIsFavoriteLocal,
  handleChange,
  handleCancel,
  handleSaveName,
  isSaving,
  hasChanges,
  showDeleteConfirm,
  setShowDeleteConfirm,
  handleDelete,
  deleteConfirmed,
  setDeleteConfirmed
}) {
  const isNameValid = Boolean(formData.name?.trim());

  return (
    <div>
      <div className="faction-edit-details-stack">
        <section className={`faction-edit-surface faction-edit-preference-card ${isFavoriteLocal ? 'is-active' : ''}`}>
          <div className="faction-edit-surface__head faction-edit-surface__head--stacked-mobile">
            <div>
              <span className="profile-panel-eyebrow">
                <i className="bi bi-star-fill"></i>
                Home
              </span>
              <h4 className="faction-edit-surface__title mb-1">Fazione preferita</h4>
              <p className="faction-edit-surface__text mb-0">
                {isFavoriteLocal
                  ? 'Questa fazione verra mostrata come riferimento principale nella home.'
                  : 'Attivala per portare questa fazione in primo piano nella home.'}
              </p>
            </div>

            <label className="faction-edit-switch-card" htmlFor="favoriteSwitch">
              <div className="faction-edit-switch-card__copy">
                <span className="faction-edit-switch-card__label">
                  {isFavoriteLocal ? 'Attiva in home' : 'Non attiva'}
                </span>
                <span className="faction-edit-switch-card__hint">
                  {isFavoriteLocal ? 'Questa e la fazione in evidenza.' : 'Puoi impostarla come default.'}
                </span>
              </div>

              <div className="form-check form-switch faction-edit-switch mb-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="favoriteSwitch"
                  checked={isFavoriteLocal}
                  onChange={e => {
                    setIsFavoriteLocal(e.target.checked);
                  }}
                />
              </div>
            </label>
          </div>
        </section>

        <section className="faction-edit-surface">
          <div className="row g-4 align-items-start">
            <div className="col-12 col-lg-7">
              <div className="faction-edit-field-card">
                <label className="form-label faction-edit-label" htmlFor="factionName">
                  <i className="bi bi-tag me-2"></i>
                  Nome fazione
                </label>
                <input
                  id="factionName"
                  type="text"
                  className={`form-control faction-edit-input ${isNameValid ? 'is-valid' : 'is-invalid'}`}
                  placeholder="Inserisci il nome della fazione"
                  value={formData.name}
                  onChange={e => handleChange('name', e.target.value)}
                  required
                />
                <div className="faction-edit-help">
                  Scegli un nome chiaro e riconoscibile: verra mostrato in profilo, home e classifiche.
                </div>
                <div className="invalid-feedback">Il nome della fazione e obbligatorio.</div>
              </div>
            </div>

            <div className="col-12 col-lg-5">
              <div className="faction-edit-logo-panel">
                <div className="faction-edit-logo-panel__copy">
                  <span className="profile-panel-eyebrow">
                    <i className="bi bi-image-fill"></i>
                    Logo
                  </span>
                  <p className="faction-edit-help mb-0">
                    Carica un logo quadrato o ben centrato per un risultato migliore in card e profilo.
                  </p>
                </div>

                <ImageUploader
                  onUploadSuccess={url => handleChange('imageUrl', url)}
                  currentImageUrl={formData.imageUrl}
                  storagePath="faction-logos"
                  buttonText={
                    <span>
                      <i className="bi bi-cloud-arrow-up me-2"></i>
                      {formData.imageUrl ? 'Sostituisci logo' : 'Carica logo'}
                    </span>
                  }
                  buttonClass="btn btn-brand faction-edit-upload-btn"
                  previewClass="img-fluid faction-edit-logo-preview"
                  previewStyle={{ maxWidth: '170px', height: 'auto', objectFit: 'contain' }}
                  infoText="Formati supportati: JPG, PNG, SVG. Max 2MB"
                  showPreview
                />
              </div>
            </div>
          </div>
        </section>
      </div>

      <div className="faction-edit-actions mt-4">
        <div className="faction-edit-actions__row roster-form-actions">
          <button
            className="btn roster-form-btn roster-form-btn--danger faction-edit-danger-btn"
            onClick={() => setShowDeleteConfirm(true)}
            title="Elimina fazione"
            type="button"
          >
            <i className="bi bi-trash me-2"></i>
            Elimina
          </button>

          <div className="faction-edit-actions__primary roster-form-actions__group">
            <button
              className="btn roster-form-btn roster-form-btn--secondary"
              onClick={handleCancel}
              disabled={isSaving}
              type="button"
            >
              <i className="bi bi-x-lg me-1"></i>
              Annulla
            </button>
            <button
              className="btn btn-brand-secondary roster-form-btn roster-form-btn--primary"
              onClick={handleSaveName}
              disabled={!hasChanges || !isNameValid || isSaving}
              type="button"
            >
              {isSaving
                ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-1"></span>
                    Salvataggio...
                  </>
                  )
                : (
                  <>
                    <i className="bi bi-check-lg me-1"></i>
                    Salva modifiche
                  </>
                  )}
            </button>
          </div>
        </div>
      </div>

      {showDeleteConfirm && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.58)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content border-0 shadow-lg faction-edit-modal">
              <div className="modal-header bg-danger text-white border-0">
                <h5 className="modal-title">
                  <i className="bi bi-exclamation-triangle-fill me-2"></i>
                  Elimina Fazione
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowDeleteConfirm(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="alert alert-danger border-0">
                  <h6 className="alert-heading">Attenzione!</h6>
                  <p className="mb-0">Questa azione e permanente e non puo essere annullata.</p>
                </div>
                <p className="mb-3">Verranno eliminati tutti i dati associati.</p>
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="confirmDelete"
                    checked={deleteConfirmed}
                    onChange={e => setDeleteConfirmed(e.target.checked)}
                  />
                  <label className="form-check-label" htmlFor="confirmDelete">
                    Confermo di voler eliminare la fazione &quot;{formData.name}&quot;
                  </label>
                </div>
              </div>
              <div className="modal-footer border-0 roster-form-actions">
                <button
                  className="btn roster-form-btn roster-form-btn--secondary"
                  onClick={() => setShowDeleteConfirm(false)}
                  type="button"
                >
                  Annulla
                </button>
                <button
                  className="btn roster-form-btn roster-form-btn--danger"
                  onClick={handleDelete}
                  disabled={!deleteConfirmed}
                  type="button"
                >
                  <i className="bi bi-trash3-fill me-2"></i>
                  Elimina
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default EditFactionFormDetails;
